<template>
    <div v-if="block.display" 
        class="home-block" 
        v-observe-visibility="{
            callback: visibilityChanged,
            intersection:{
                rootMargin: `${block.observeMargin}px 0px ${block.observeMargin}px 0px`
            }
        }" :id="block.elementId">
        <h2 v-if="block.title" v-html="!isLoading ? block.title : '&nbsp;'"></h2>
        <img v-if="!isLoading && block.titleBanner" :src="block.titleBanner" class="block-title-banner" :alt="block.title" @click="gotoUrl(block.showMore ? block.showMore.url : '')">
        <span class="block-subtitle" v-if="block.subTitle" v-html="block.subTitle"></span>
        <div v-if="diamondText" class="diamond-lext">
            <div class="slider-margin">&nbsp;</div> 
            <p v-html="diamondText.text"></p>
        </div>
        <div class="home-block-content" :style="{height: `${blockHeight}px`}" >
            <div v-show="inViewPort" class="home-products-scroll" ref="block" dir="ltr">
                <div class="block-content" :style="{height: `${blockHeight}px`}" >
                    <div class="blocks">
                        <div class="slider-margin">&nbsp;</div> 
                        <template v-if="isLoading">
                            <div class="slider-itens">
                                <div v-for="n in Math.ceil(block.numberItens)" class="slider-item" :key="n" :style="{width: `${blockWidth}px`,height: `${blockHeight}px`}">
                                    <div class="slider-item-content skeleton-box"></div>
                                </div>
                            </div>
                        </template> 
                        <div v-for="blockItem in blockItems" :key="blockItem.key" class="slider-item" :style="{width: !blockItem.widthRate ? `${blockWidth}px` : `${blockWidth * blockItem.widthRate}px`}">
                            <DiamondHtml v-if="blockItem.id == 'html'" :content="blockItem" :blockWidth="blockWidth" />
                            <DiamondInfo v-else-if="blockItem.id == 'info'" :content="blockItem" :blockWidth="blockWidth" />
                            <div v-else-if="blockItem.type == 'advantage'" class="slider-item-content" :style="{borderWidth: `${borderWidth}px;`, background: (block.type == 'VerticalProducts') ? `url('${blockItem.image}') center center / cover` : null}" @click="gotoUrl(block.advantages ? block.advantages.url : '')">
                                <BlockImage v-if="block.type != 'VerticalProducts'" :classNames="'w-100 h-100'" :classNamesBox="'w-100 h-100'" :isScrolled="isScrolled" :image="blockItem.image" :width="blockWidth" :height="blockHeight" :title="'Prozis'"></BlockImage>
                            </div>
                            <keep-alive v-else>
                                <block-item :fn-goto-url="gotoUrl" :numeration="numeration" :item="blockItem" :borderWidth="borderWidth" :width="blockWidth" :height="blockHeight" :isDesktop="false" :type="block.type" :inViewPort="inViewPort" :is-hoverand-zoom-activated="block.isHoverandZoomActivated" ></block-item>
                            </keep-alive>
                        </div>
                        <Mub v-if="!isLoading && block.hasDiscovery" :rawData="block.mubDataViewMore">
                            <div class="slider-item slider-item-discovery" :style="{width: `${blockWidth}px`}" @click="gotoUrl(block.discovery.url)">
                                <div class="top-shadow"></div>
                                <div class="slider-item-content slider-box-view-more">
                                    <div class="w-100 text-center">{{block.discovery.title}}</div>
                                    <div><a class="discovery" :href="block.discovery.url">{{block.discovery.label}}</a></div>
                                </div>
                                <div class="bottom-shadow"></div>
                            </div>
                        </Mub>
                        <div class="slider-margin">&nbsp;</div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import BlockItem from '../Partials/BlockItem';
import BlockImage from '../../Common/Partials/BlockImage';
import BlockLikes from '../../Common/Partials/BlockLikes';
import BlockLabel from '../Partials/BlockLabel';
import HomeBlock from '@/models/home-block';
import homeUtils from '@/Utilities/homeUtils';
import Mub from '@/components/Mub';

import DiamondHtml from '@/components/DiamondModal/DiamondHtml'; 
import DiamondInfo from '@/components/DiamondModal/DiamondInfo'; 

export default {
    components:{
        BlockImage,
        BlockLabel,
        BlockLikes,
        Mub,
        DiamondHtml,
        DiamondInfo,
        BlockItem
    },
    props:{
        block:{
            type: HomeBlock
        },
        heightRate:{
            type: Number,
            default: 1
        },
        widthRate:{
            type: Number,
            default: 1
        },
        numeration:{
            type: Boolean,
            default: false
        },
        margin:{
            type: Number,
            default: 3
        },
        borderWidth:{
            type: Number,
            default: 2
        }
    },
    data(){
        return{
            selectedEle: null,
            blockHeight: 0,
            blockWidth: 0,
            viewWidth: 0,
            inViewPort: false,
            isScrolled: false
        }
    },
    mounted() {
        this.calcSize();
    },
    
    created() {
        window.addEventListener("resize", this.calcSize);
    },
    destroyed() {
        window.removeEventListener("resize", this.calcSize);
    },
    computed: {
        isLoading(){
            return this.block && this.block.isLoading;
        },
        roundNumberProducts(){
            return Math.floor(this.block.numberItens);
        },
        isDiamond(){
            return this.block.diamond ? true : false;
        },
        blockItems(){
            let items = this.block.items;
            if(!this.isDiamond){
                return items;
            }
            // return all elements except "text"
            return items ? items.filter(item => item.id !== 'text') : [];
        },
        diamondText(){
            // return "text" element
            let dataContent = this.block.items;
            const item = this.isDiamond && dataContent ? dataContent.filter(item => item.id === 'text') : null;
            return item && item.length ? item[0] : null;
        },
    },
    watch:{
        inViewPort(newValue, oldValue){
            if(newValue && this.isDiamond && this.block.diamond.scrollToCoupon){
                // use next tick because right now element does not have content (width = 0)
                this.$nextTick(() => {
                    this.$refs.block.scrollLeft = 1920;
                });                
            }
        }
    },
    methods: {
        visibilityChanged(isVisible){
            this.inViewPort = isVisible;
            if(isVisible && this.block.isLoading){
                this.block.load();
            }
        },
        gotoUrl(url){
            if(url && url.includes('javascript:')){
                return;
            }
            homeUtils.gotoUrl(url,this.block);
        },
        // detailsClick(){
        //     if (this.selectedEle.hasAttribute("data-url")) {
        //         this.gotoUrl(this.selectedEle.dataset.url);
        //     }
        // },
        calcSize(){
            this.viewWidth   = homeUtils.getViewPortWidth(true);
            let marWidth     = Math.round(this.viewWidth * (this.margin * 2 / 100));
            let proWidth     = (this.viewWidth - marWidth) / this.block.numberItens;
            this.blockWidth  = Math.round(proWidth);
//            this.blockHeight = this.blockWidth * this.heightRate;
            this.blockHeight        = (this.blockWidth / this.widthRate ) * this.heightRate;
            this.viewMoreBlockWidth = this.blockWidth / this.widthRate;

        },
    }
}
</script>
